module.exports = "/_next/static/images/10-a421ba8ebf05ac95093f14604c5cd05f.png";